<template>
    <div>
        <div class="separator-line m-t-16 m-d-16" />
        <div class="f-16 f-bold p-d-16">
            Benefit Non Diskon
        </div>
        <div class="f-c-midgrey f-12">
            <div class="f-14 f-c-text-primary">
                {{ name }}
            </div>
            <div v-if="benefit.voucher">{{ benefit.voucher.name }} • 1 Pcs </div>
            <div v-if="benefit.free_inventory">{{benefit.free_inventory.name}} • {{ benefit.free_inventory.qty }} {{ benefit.free_inventory.unit_name }}</div>
            <div v-if="benefit.free_gift">{{benefit.free_gift.gift_name}} • {{ benefit.free_gift.qty }} {{ benefit.free_gift.unit_name == '' ? 'pcs' : benefit.free_gift.unit_name}}</div>
            <div v-if="benefit.cashback">Cashback • {{ benefit.cashback.value }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SOBenefitPromo",
    props: {
        promo: Object,
    },
    computed: {
        name() {
            return this.promo.meta.name
        },
        benefit() {
            return this.promo.non_discount
        },
    }
}
</script>
<style scoped>
.separator-line {
	border-top: 3px solid #C8D0DD !important;
}
</style>